import { UnknownError } from '@cian/peperrors';

import { assertions } from './assertions';
import { TPayload } from '../../../repositories/chats/entities/message/MessageRequestV2Schema';
import { fetchMessagesOffer } from '../../../repositories/chats/v3/messages/offer';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed, setFirstMessagePending } from '../actions';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { mappers } from '../mappers';
import { TFirstMessageResponse } from '../types';
import { getDomainBySource, getTelemetryBySource } from '../utils';

interface ISendFirstMessageOfferProps {
  /** Токен капчи(для проверки валидности, только desktop) **/
  captchaToken?: string;
  /** Идентификатор объявления **/
  offerId: number;
  /** Текст сообщения **/
  text: string;
  /** Пэйлоад для субсидированной ипотеки **/
  payload?: string;
  /** Флаг отключения аналитики ключа **/
  isAnalyticsKeyDisabled?: boolean;
}

const SOURCE = 'offer';

/**
 * @description
 * Отправка первого сообщения по объявлению
 */
export const sendFirstMessageOffer =
  ({
    offerId,
    text,
    captchaToken,
    payload,
    isAnalyticsKeyDisabled,
  }: ISendFirstMessageOfferProps): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, telemetry, logger }) => {
    dispatch(setFirstMessagePending());

    const offerTelemetry = getTelemetryBySource(telemetry, SOURCE);

    const domain = getDomainBySource(SOURCE);

    offerTelemetry.increment(ETelemetryEvents.ChatFirstMessageSendInit);

    const startTime = Date.now();

    try {
      const response = (await fetchMessagesOffer({
        httpApi,
        parameters: {
          offerId,
          text,
          captchaToken,
          payload: payload ? (payload as TPayload) : undefined,
        },
        mappers,
      })) as TFirstMessageResponse;

      assertions.forEach(assertion => {
        dispatch(
          assertion(response, {
            domain,
            telemetry: offerTelemetry,
            isAnalyticsKeyDisabled,
            text,
            startTime,
          }),
        );
      });
    } catch (error) {
      offerTelemetry.increment(ETelemetryEvents.ChatFirstMessageSendUnknownError);

      const unknownError = new UnknownError({
        message: DEFAULT_ERROR_MESSAGE,
        domain,
        details: error,
      });

      logger.error(unknownError);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({}));
    }
  };
